<template>
  <div>
    <el-dialog
      ref="viewDialog"
      v-dialogDrag
      :title="dialogTitle"
      :visible.sync="dialogVisible"
      class="abow_dialog h450_dialog"
      width="1100px"
      :before-close="modalClose"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      append-to-body
    >
      <el-form
        ref="dialogViewForm"
        :model="dialogViewForm"
        class="add-edit-view-form"
        @submit.native.prevent
      >
        <div class="modal-box">
          <h3 class="modal-title">
            高价值零售户信息
          </h3>
          <div class="modal-row-box">
            <el-row :gutter="10">
              <el-col :span="6">
                <el-form-item label="省区">
                  <el-input
                    v-model="dialogViewForm.provinceName"
                    disabled
                  />
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item label="城市">
                  <el-input
                    v-model="dialogViewForm.cityName"
                    disabled
                  />
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item label="专卖证号">
                  <el-input
                    v-model="dialogViewForm.certificateNo"
                    disabled
                  />
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item label="档位">
                  <el-input
                    v-model="dialogViewForm.level"
                    disabled
                  />
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="10">
              <el-col :span="12">
                <el-form-item label="零售户名称">
                  <el-input
                    v-model="dialogViewForm.storeName"
                    disabled
                  />
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item label="市场类型">
                  <el-input
                    v-model="dialogViewForm.marketType"
                    disabled
                  />
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item label="业态">
                  <el-input
                    v-model="dialogViewForm.businessType"
                    disabled
                  />
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="10">
              <el-col :span="6">
                <el-form-item label="经营能力">
                  <el-input
                    v-model="dialogViewForm.businessCapacity"
                    disabled
                  />
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item label="贡献能力">
                  <el-input
                    v-model="dialogViewForm.contributeCapacity"
                    disabled
                  />
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item label="发展潜力">
                  <el-input
                    v-model="dialogViewForm.developmentPotential"
                    disabled
                  />
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="10">
              <el-col :span="6">
                <el-form-item label="版本号">
                  <el-input
                    v-model="dialogViewForm.versionCode"
                    disabled
                  />
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item label="最新版本">
                  <el-radio-group
                    v-model="dialogViewForm.newestVersion"
                    disabled
                  >
                    <el-radio :label="1">
                      是
                    </el-radio>
                    <el-radio :label="2">
                      否
                    </el-radio>
                  </el-radio-group>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item label="操作人">
                  <el-input
                    v-model="dialogViewForm.operatorName"
                    disabled
                  />
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item label="操作时间">
                  <el-input
                    v-model="dialogViewForm.operationTime"
                    disabled
                  />
                </el-form-item>
              </el-col>
            </el-row>
          </div>
        </div>
      </el-form>
      <div
        slot="footer"
        class="dialog-footer"
      >
        <el-button @click="modalClose">
          关闭
        </el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
// dialog 拖拽dialogDragMixin
import dialogDragMixin from '@/mixin/dialogDragMixin'
// 数据请求
import { viewHighValueStoreApi } from '@/api/v2/highValueStore'

export default {
  components: {},
  mixins: [dialogDragMixin],
  props: {
    dialogTitle: {
      type: String,
      default: ''
    },
    eventType: {
      type: String,
      default: ''
    },
    dialogVisible: {
      type: Boolean,
      default: false
    },
    dataId: {
      type: Number,
      default: 0
    }
  },
  data () {
    return {
      dialogViewForm: {},
    }
  },
  watch: {
    dialogVisible (val) {
      if (val) {
        let _this = this;
        _this.dialogViewForm = {};
        _this.initViewData();
      }
    }
  },
  methods: {
    // 加载数据
    initViewData () {
      let _this = this;
      viewHighValueStoreApi({ id: _this.dataId }).then(response => {
        const { data } = response
        _this.dialogViewForm = data || {};
      })
    },
    // 关闭弹框
    modalClose () {
      this.$emit('update:dialogVisible', false)
    },
  }
}
</script>
<style lang="scss" scoped>
</style>
